import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/services.css';


import breadcrumbBg from '../assets/img/bg/breadcrumb-bg-2.png';
import cloudIcon from '../assets/img/icons/cloud.png';
import balloonIcon from '../assets/img/icons/ballon-sclation.png';

const Services = () => {
    const [airTicketData, setAirTicketData] = useState({
        from: '',
        to: '',
        departure: '',
        return: '',
        passengers: '1 Adult',
        class: 'Economy'
    });

    const [carRentalData, setCarRentalData] = useState({
        pickupLocation: '',
        dropoffLocation: '',
        pickupDate: '',
        dropoffDate: '',
        carType: 'Economy',
        rentalCompany: 'Any Company'
    });

    const handleAirTicketChange = (e) => {
        setAirTicketData({
            ...airTicketData,
            [e.target.name]: e.target.value
        });
    };

    const handleCarRentalChange = (e) => {
        setCarRentalData({
            ...carRentalData,
            [e.target.name]: e.target.value
        });
    };

    const handleAirTicketSubmit = (e) => {
        e.preventDefault();
        console.log('Air Ticket Search:', airTicketData);
        alert('Searching for flights...');
    };

    const handleCarRentalSubmit = (e) => {
        e.preventDefault();
        console.log('Car Rental Search:', carRentalData);
        alert('Searching for cars...');
    };

    // Services data
    const services = [
        {
            id: 1,
            icon: 'fa-plane',
            title: 'Air Ticketing',
            description: 'Domestic and international flights with the best deals and flexible options.'
        },
        {
            id: 2,
            icon: 'fa-car',
            title: 'Car Rentals',
            description: 'Flexible car rental services with convenient pickup and drop-off locations.'
        },
        {
            id: 3,
            icon: 'fa-money-bill-wave',
            title: 'Sight Seeing',
            description: 'Enjoy sightseeing with us.'
        }
    ];

    return (
        <div className="services-page">
            {/* Breadcrumb Section */}
            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: `url(${breadcrumbBg})` }}
            >
                <img
                    src={cloudIcon}
                    alt="cloud icon"
                    className="vs-breadcrumb-icon-1 animate-parachute"
                />
                <img
                    src={balloonIcon}
                    alt="balloon icon"
                    className="vs-breadcrumb-icon-2 animate-parachute"
                />
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <h1 style={{ color: '#e9ecef' }}>Our Services</h1>
                            <p className="lead" style={{ color: '#e9ecef' }}>
                                Experience world-class travel services tailored to your needs
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Rest of your component remains the same */}
            {/* Featured Services Section */}
            <section className="featured-services-section">
                <div className="container">
                    <div className="section-title">
                        <h2>Featured Services</h2>
                        <p>Book your travel essentials with ease and confidence</p>
                    </div>

                    <div className="row">
                        {/* Air Ticketing Card */}
                        <div className="col-lg-6">
                            <div className="service-booking-card">
                                <h3>Air Ticketing</h3>
                                <p className="mb-4">
                                    Book domestic and international flights with the best deals and flexible options.
                                </p>
                                <form className="booking-form" onSubmit={handleAirTicketSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="from">From</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="from"
                                                    name="from"
                                                    value={airTicketData.from}
                                                    onChange={handleAirTicketChange}
                                                    placeholder="Departure city"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="to">To</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="to"
                                                    name="to"
                                                    value={airTicketData.to}
                                                    onChange={handleAirTicketChange}
                                                    placeholder="Destination city"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="departure">Departure</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="departure"
                                                    name="departure"
                                                    value={airTicketData.departure}
                                                    onChange={handleAirTicketChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="return">Return</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="return"
                                                    name="return"
                                                    value={airTicketData.return}
                                                    onChange={handleAirTicketChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="passengers">Passengers</label>
                                                <select
                                                    className="form-control"
                                                    id="passengers"
                                                    name="passengers"
                                                    value={airTicketData.passengers}
                                                    onChange={handleAirTicketChange}
                                                >
                                                    <option>1 Adult</option>
                                                    <option>2 Adults</option>
                                                    <option>Family (2 Adults, 2 Children)</option>
                                                    <option>Group (4+ People)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="class">Class</label>
                                                <select
                                                    className="form-control"
                                                    id="class"
                                                    name="class"
                                                    value={airTicketData.class}
                                                    onChange={handleAirTicketChange}
                                                >
                                                    <option>Economy</option>
                                                    <option>Premium Economy</option>
                                                    <option>Business</option>
                                                    <option>First Class</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-booking w-100" style={{
                                        background: 'linear-gradient(135deg, #eab366ff 0%, #d3940cff 100%)',
                                        color: 'white',
                                        border: 'none',
                                        padding: '15px 30px',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                                        transition: 'all 0.3s ease',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px'
                                    }}>
                                        Search Flights
                                    </button>
                                </form>
                            </div>
                        </div>

                        {/* Car Rentals Card */}
                        <div className="col-lg-6">
                            <div className="service-booking-card">
                                <h3>Car Rentals</h3>
                                <p className="mb-4">
                                    Rent a car for your travel needs with flexible pickup and drop-off locations.<br/>
                                    <br/>
                                </p>
                                <form className="booking-form" onSubmit={handleCarRentalSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pickup-location">Pickup Location</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="pickup-location"
                                                    name="pickupLocation"
                                                    value={carRentalData.pickupLocation}
                                                    onChange={handleCarRentalChange}
                                                    placeholder="City or Airport"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="dropoff-location">Drop-off Location</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="dropoff-location"
                                                    name="dropoffLocation"
                                                    value={carRentalData.dropoffLocation}
                                                    onChange={handleCarRentalChange}
                                                    placeholder="City or Airport"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pickup-date">Pickup Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="pickup-date"
                                                    name="pickupDate"
                                                    value={carRentalData.pickupDate}
                                                    onChange={handleCarRentalChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="dropoff-date">Drop-off Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="dropoff-date"
                                                    name="dropoffDate"
                                                    value={carRentalData.dropoffDate}
                                                    onChange={handleCarRentalChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="car-type">Car Type</label>
                                                <select
                                                    className="form-control"
                                                    id="car-type"
                                                    name="carType"
                                                    value={carRentalData.carType}
                                                    onChange={handleCarRentalChange}
                                                >
                                                    <option>Economy</option>
                                                    <option>Compact</option>
                                                    <option>Mid-size</option>
                                                    <option>Full-size</option>
                                                    <option>SUV</option>
                                                    <option>Luxury</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="rental-company">Rental Company</label>
                                                <select
                                                    className="form-control"
                                                    id="rental-company"
                                                    name="rentalCompany"
                                                    value={carRentalData.rentalCompany}
                                                    onChange={handleCarRentalChange}
                                                >
                                                    <option>Any Company</option>
                                                    <option>Hertz</option>
                                                    <option>Avis</option>
                                                    <option>Enterprise</option>
                                                    <option>Budget</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-booking w-100" style={{
                                        background: 'linear-gradient(135deg, #eab366ff 0%, #d3940cff 100%)',
                                        color: 'white',
                                        border: 'none',
                                        padding: '15px 30px',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                                        transition: 'all 0.3s ease',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px'
                                    }}>
                                        Find Cars
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* All Services Section */}
            <section className="all-services-section">
                <div className="container">
                    <div className="section-title">
                        <h2>All Our Services</h2>
                        <p>Comprehensive travel solutions for all your needs</p>
                    </div>

                    <div className="row">
                        {services.map((service) => (
                            <div key={service.id} className="col-md-6 col-lg-4">
                                <div className="service-item">
                                    <div className="service-icon">
                                        <i className={`fa-solid ${service.icon}`}></i>
                                    </div>
                                    <h4>{service.title}</h4>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Services;